module.exports = __webpack_public_path__ + "static/media/IMG_1455X.b3b3ea06.JPG";